import { Controller } from "@hotwired/stimulus"
import { animate, cubicBezier } from "animejs"

// Connects to data-controller="pages--cookies"
export default class extends Controller {
  static values = {
    hide: Boolean
  }

  connect() {
    if (this.hideValue) {
      animate(this.element, {
        translateY: ["0%", "100%"],
        ease: cubicBezier(0.1, 0.7, 0.5, 1),
      })
    }
  }
}
